export const MED_FORMS = ["Tablet", "Capsule", "Liquid", "Solution", "Suspension", "Injection", "Cream", "Ointment", "Gel", "Patch",
  "Sublingual Film", "Suppository", "Inhaler", "Nasal Spray", "Drops", "Powder", "Lozenge", "Other"];
export const MED_ROUTES = ["Oral (PO)", "Sublingual (SL)", "Intramuscular (IM)", "Intravenous (IV)", "Subcutaneous (SC)", "Topical",
  "Inhaled", "Rectal (PR)", "Otic", "Ophthalmic", "Nasal", "Transdermal", "Other"];
export const presentationLabel = (p) => [p.strength, p.form, p.route].filter(Boolean).join(" · ");
